export const contentStyles = [
    {
        value: 'standard',
        label: 'Standard',
        disabled: false,
    },
    {
        value: 'safe',
        label: 'Family-Friendly',
        disabled: false,
    },
    {
        value: 'edgy',
        label: 'Edgy',
        disabled: false,
    },
];
//# sourceMappingURL=contentStyles.js.map